import { AudioInputSettings, AudioOutputSettings, DeviceId } from '../UserContext'
import { persistent } from '../services/LocalStorage'

type MediaDeviceType = 'AudioInputDevice' | 'AudioOutputDevice'

export default class AudioSettingsStore {
    static get(deviceId: DeviceId, deviceType: MediaDeviceType) {
        const s = persistent.getObject(this.generateKey(deviceId, deviceType))
        return s || null
    }

    static set(deviceId: DeviceId, deviceType: MediaDeviceType, settings: AudioInputSettings | AudioOutputSettings) {
        persistent.set(this.generateKey(deviceId, deviceType), settings)
    }

    static generateKey(deviceId: DeviceId, deviceType: MediaDeviceType) {
        return `AudioSettingsStore::${deviceType}::${deviceId}`
    }

    static isKey(candidate: string, deviceType: MediaDeviceType) {
        return candidate.startsWith(`AudioSettingsStore::${deviceType}`)
    }

    static getDeviceIdFromKey(key: string) {
        return key.split('::')[2] || null
    }

    static getSettingsLookupByDeviceType() {
        const keys = persistent.getKeys()
        const audioInputKeys = keys.filter((a) => this.isKey(a, 'AudioInputDevice'))
        const audioOutputKeys = keys.filter((a) => this.isKey(a, 'AudioOutputDevice'))

        const audioInputs: { [key: string]: AudioInputSettings } = {}
        const audioOutputs: { [key: string]: AudioOutputSettings } = {}

        audioInputKeys.forEach((key) => {
            const settings = persistent.getObject(key) as AudioInputSettings
            const deviceId = this.getDeviceIdFromKey(key)
            if (deviceId) {
                audioInputs[deviceId] = settings
            }
        })

        audioOutputKeys.forEach((key) => {
            const settings = persistent.getObject(key) as AudioOutputSettings
            const deviceId = this.getDeviceIdFromKey(key)
            if (deviceId) {
                audioOutputs[deviceId] = settings
            }
        })

        return { audioInputs, audioOutputs }
    }
}
